import { render } from "./PolicyVehicle.vue?vue&type=template&id=2f53ac85"
import script from "./PolicyVehicle.vue?vue&type=script&lang=js"
export * from "./PolicyVehicle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__